import { Api } from '../helpers';

const resoAssistService = {
  fetchSOP(data) {
    const path = '/issues/v2/reso_assist/get_details';
    const body = data;
    return Api.post({ path }, { body });
  },
};

export default resoAssistService;
